import React from 'react'
import {
  FiDollarSign,
  FiEye,
  FiImage,
  FiPackage,
  FiPercent,
  FiRefreshCw,
  FiShoppingBag,
  FiShoppingCart
} from 'react-icons/fi'
import { HiOutlineCursorClick } from 'react-icons/hi'
import { HiOutlineMegaphone } from 'react-icons/hi2'
import { IoMdPerson } from 'react-icons/io'
import { IoRocketOutline } from 'react-icons/io5'
import { MdAdsClick } from 'react-icons/md'

const commonIcons: CardIconsPublisher | CardIconsAdvertiser = {
  views: <FiEye className="text-warning" />,
  prints: <FiImage className="text-info" />,
  clicks: <HiOutlineCursorClick style={{ color: '#3c3584' }} />,
  conversions: <FiShoppingBag className="text-success" />,
  conversion_rate: <MdAdsClick className="text-success" />,
  conversion_rate_click: <MdAdsClick className="text-success" />,
  conversions_click: <FiShoppingBag className="text-success" />,
  campaigns: <IoRocketOutline className="text-primary" />,
  total_spent: <FiDollarSign className="text-success" />,
  ctr: <FiPercent className="text-primary" />,
  income: <FiDollarSign className="text-success" />,
  conversion: <FiShoppingBag className="text-success" />,
  actives_campaigns: <IoRocketOutline className="text-info" />,
  ads_income: <FiDollarSign className="text-success" />,
  sales_income: <FiShoppingBag className="text-warning" />,
  actives_advertisers: <HiOutlineMegaphone className="text-primary" />,
  roas: <FiRefreshCw className="text-primary" />,
  impression_share: <FiPercent className="text-primary" />,
  lost_is_rank: <FiPercent className="text-primary" />,
  lost_is_budget: <FiPercent className="text-primary" />,
  new_to_brand_customers: <IoMdPerson className="text-warning" />,
  new_to_brand_customers_percent: <FiPercent className="text-warning" />,
  new_to_brand_revenue: <FiDollarSign className="text-success" />,
  new_to_brand_revenue_percent: <FiPercent className="text-success" />,
  roas_click: <FiRefreshCw className="text-primary" />,
  halo_revenue: <FiDollarSign className="text-success" />,
  roas_halo: <FiRefreshCw className="text-success" />,
  halo_orders: <FiShoppingCart className="text-info" />,
  halo_items: <FiPackage className="text-info" />,
  roas_overall: <FiRefreshCw className="text-success" />
}

export const dashboardIcons: CardIcons = {
  publisher: { ...commonIcons },
  advertiser: { ...commonIcons }
}
